import Splide from '@splidejs/splide';

export default function initSliderCarousels() {
    const elements = document.querySelectorAll('.slider-carousel');

    elements.forEach(el => {
        new Splide(el, {
            lazyLoad: 'nearby',
            autoWidth: true,
            focus: 'left',
            gap: '20px',
            pagination: false,
        }).mount();
    });
}
